(() => {
  const globalKey = '__gemlayPurchaseLayoutInitialized';

  const arrangePurchaseControls = () => {
    document.querySelectorAll('.gemlay-pdp').forEach((root) => {
      const quantity = root.querySelector('.gemlay-pdp__quantity');
      const buttons = root.querySelector('.gemlay-pdp__buy .product-form__buttons');
      const submit = buttons?.querySelector('.product-form__submit');

      if (!quantity || !buttons || !submit) return;

      if (quantity.parentElement !== buttons) {
        buttons.insertBefore(quantity, submit);
      }

      buttons.classList.add('gemlay-purchase-layout');
      quantity.classList.add('gemlay-purchase-layout__quantity');
      submit.classList.add('gemlay-purchase-layout__submit');

      const quantityLabel = quantity.querySelector('.quantity__label');
      quantityLabel?.classList.add('visually-hidden');

      const dynamicCheckout = buttons.querySelector('.product-form__dynamic-checkout');
      dynamicCheckout?.classList.add('gemlay-purchase-layout__dynamic');
    });
  };

  const schedulePurchaseLayout = () => {
    window.requestAnimationFrame(arrangePurchaseControls);
  };

  if (window[globalKey]) {
    schedulePurchaseLayout();
    return;
  }

  window[globalKey] = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePurchaseLayout, { once: true });
  } else {
    schedulePurchaseLayout();
  }

  document.addEventListener('product-info:loaded', schedulePurchaseLayout);
  document.addEventListener('shopify:section:load', schedulePurchaseLayout);
})();
